let apiUrl,pcdUrl,CSMUrl,PFMUrl,ImgBaseUrl;

console.log(
  process.env.VUE_APP_API_ENV,123123133
);

let reg = /\S+(?=\/\w+.html)/;
let str = window.location.pathname.match(reg)?.[0];
switch (process.env.VUE_APP_API_ENV) {
    case "development":
    apiUrl = "https://kiatest.fontre.com/apiWeb/v1/kia/";
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`;
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    ImgBaseUrl = "https://uat.kia.cn";
    break;
    case "uat":
    apiUrl = "https://kiatest.fontre.com/apiWeb/v1/kia/";
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    ImgBaseUrl = "https://uat.kia.cn";
    break;
    case "production":
    apiUrl = "https://api-v2.kia.cn:8001/apiWeb/v1/kia/";
    pcdUrl = "/assets/~/media/files/genfiles/pcd.js"
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    ImgBaseUrl = "https://www.kia.cn";
    break;
    default:
    apiUrl = "https://kiatest.fontre.com/apiWeb/v1/kia/";
    pcdUrl = `${window.location.origin}${str || ''}/js/pcd.js`
    CSMUrl = `${window.location.origin}${str || ''}/js/carSeriesModel.js`;
    PFMUrl = `${window.location.origin}${str || ''}/js/cityPerformance.js`;
    ImgBaseUrl = "https://uat.kia.cn";
    break;
}

export { apiUrl, pcdUrl,CSMUrl,PFMUrl,ImgBaseUrl};
